<template>
  <div id="logon-modal" uk-modal>
    <div class="uk-modal-dialog">
      <form id="logon-form" class="uk-form-horizontal" novalidate="true" autocomplete="off" @submit.prevent="userLogon($event)">
        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>
        <div class="uk-modal-header">
          <h2 class="uk-modal-title">{{ modalTitle }}</h2>
        </div>
        <div class="uk-modal-body">
          <div v-if="!userResetPasswordMode">{{ $t('user.login.description') }}</div>
          <div v-else>
            {{ $t('user.reset.description') }}
            <h4 class="uk-text-primary">{{ $t('user.reset.steps.0.title') }}</h4>
            <p v-html="$t('user.reset.steps.0.description')" class="uk-text-meta"></p>
          </div>
          <div class="uk-margin">
            <label class="uk-form-label" for="user-logon-email">{{ $t('user._common.fields.email') }}</label>
            <div class="uk-form-controls">
              <input class="uk-input" id="user-logon-email" type="email" name="email" data-validate="required,email" :readonly="userResetPasswordMode && userResetPasswordStep === 2" />
            </div>
          </div>
          <div class="uk-margin" :hidden="userResetPasswordMode">
            <label class="uk-form-label" for="user-logon-password">{{ $t('user._common.fields.password') }}</label>
            <div class="uk-form-controls">
              <input class="uk-input" id="user-logon-password" type="password" name="password" data-validate="required" :disabled="userResetPasswordMode" />
            </div>
          </div>
          <div v-if="userResetPasswordMode && userResetPasswordStep === 2">
            <h4 class="uk-text-primary">{{ $t('user.reset.steps.1.title') }}</h4>
            <p v-html="$t('user.reset.steps.1.description')" class="uk-text-meta"></p>
            <div class="uk-margin">
              <label class="uk-form-label" for="user-reset-token">{{ $t('user.reset.fields.token') }}</label>
              <div class="uk-form-controls">
                <input class="uk-input" id="user-reset-token" type="text" name="token" data-validate="required" :disabled="!userResetPasswordMode || userResetPasswordStep < 2" />
              </div>
            </div>
            <div class="uk-margin">
              <label class="uk-form-label" for="user-reset-password">{{ $t('user.reset.fields.new_password') }}</label>
              <div class="uk-grid-small uk-child-width-1-2@s" uk-grid>
                <div><input class="uk-input" id="user-reset-password" type="password" name="new-password" data-validate="required" :disabled="!userResetPasswordMode || userResetPasswordStep < 2" /></div>
                <div for="user-reset-password_confirmation"><input class="uk-input" id="user-reset-password_confirmation" type="password" name="new-password_confirmation" data-validate="required,passwordMatch" data-validate-helper="target: #user-reset-password; label: [for='user-reset-password_confirmation']" :placeholder="$t('user._common.fields.confirm_password')" :disabled="!userResetPasswordMode || userResetPasswordStep < 2" /></div>
              </div>
            </div>
            <p class="uk-text-meta">
              <span v-html="$t('user.reset.steps.1.restart.description')"></span>
              <button type="button" class="uk-button uk-button-text uk-margin-small-left" @click="userResetRestart($event)">{{ $t('user.reset.steps.1.restart.button') }}</button>
            </p>
          </div>
        </div>
        <div class="uk-modal-footer">
          <span>
            <button type="button" class="uk-button uk-button-link uk-margin-small-right uk-text-lowercase" @click="userSwitchTo('account', $event)">{{ $t('user.account.create.menu') }}</button>
            <button type="button" class="uk-button uk-button-link uk-text-lowercase" @click="userSwitchTo(null, $event)">{{ modalButton('reset') }}</button>
          </span>
          <div class="uk-align-right uk-text-right">
            <button type="button" class="uk-button uk-button-default uk-margin-small-right uk-modal-close">{{ $t('buttons.cancel') }}</button>
            <button type="submit" class="uk-button uk-button-danger" :disabled="formIsBusy">{{ modalButton('submit') }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { createNewProject } from '@/store/mixins'
import { serializeForm, clearFormErrors } from '@/utils/qdev'

export default {
  data () {
    return {
      userResetPasswordMode: false,
      userResetPasswordStep: 1,
      formIsBusy: false
    }
  },

  computed: {
    modalTitle () {
      const type = !this.userResetPasswordMode ? 'login' : 'reset'

      return this.$t(`user.${type}.title`)
    }
  },

  mounted () {
    // upon modal open - switch it into logon mode & focus first input
    uikit.util.on('#logon-modal', 'show', event => {
      this.userResetPasswordMode = false
      // this.userResetPasswordStep = 1

      setTimeout(() => {
        const input = event.target.querySelector('input:not([disabled]):not([readonly])')

        if (input) {
          input.focus()
        }
      }, 100)
    })
  },

  methods: {
    modalButton (target = 'submit') {
      let result = this.$t('buttons.busy')

      if (target !== 'submit' || !this.formIsBusy) {
        let type = 'login'

        if ((target === 'submit' && this.userResetPasswordMode) || (target === 'reset' && !this.userResetPasswordMode)) {
          type = 'reset'
        }

        result = this.$t(`user.${type}.menu`)
      }

      return result
    },

    // submit can also mean resetPassword !
    // TODO: shall we split & move this code into store ?
    userLogon (event = null) {
      const form = event ? event.target : document.getElementById('logon-form')
      const _this = this

      this.$root.$emit('validateForm', form)

      if (form.querySelectorAll(':not([hidden]) > [data-error]').length === 0 && !this.formIsBusy) {
        const method = !this.userResetPasswordMode ? 'login' : 'reset'

        this.formIsBusy = true

        uikit.util.ajax(`api/user`, {
          method: 'post', // options
          responseType: 'json',
          data: serializeForm(form) + `&customMethod=${method}`,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
          }
        }).then(function (xhr) {
          const method = !_this.userResetPasswordMode ? 'login' : 'reset'

          // if success
          if (xhr.response.success) {
            // reset password
            if (method === 'reset') {
              if (_this.userResetPasswordStep === 1) {
                _this.userResetPasswordStep = 2

                setTimeout(() => {
                  const input = form.querySelector('input:not([disabled]):not([readonly])')

                  if (input) {
                    input.focus()
                  }
                }, 100)

                uikit.notification(`<p class="uk-h3 uk-text-success"><span class="uk-margin-small-right" uk-icon="happy"></span>${_this.$t('user.reset.steps.0.success')}</p>`, {pos: 'bottom-right', status: 'success'})
              } else {
                // finished password reset
                _this.userResetRestart()

                _this.userResetPasswordMode = false

                uikit.notification(`<p class="uk-h3 uk-text-success"><span class="uk-margin-small-right" uk-icon="happy"></span>${_this.$t('user.reset.steps.1.success')}</p>`, {pos: 'bottom-right', status: 'success'})
              }
            } else {
              // login user
              // _this.$store.state.user = xhr.response.user
              _this.$store.dispatch('userLogin', xhr.response.user).then(() => {
                _this.$store.dispatch('menuAdmin', {show: true, skipServerCheck: true})
              })

              // make a backup of local data (we'll restore it on logout)
              let projects = _this.$store.getters['db/projects/query']()
                .with('contacts')
                .with('slabs.*')
                .all()

              let selected = _this.$store.state.elementId

              // can fail if user privacy mode doesnt allow localStorage
              try {
                localStorage.setItem(`${_this.$store.state.lsKey}_backup`, JSON.stringify({projects, selected}))
              } catch (err) {
              }

              // check if we have data from server, if not create blank

              // TODO: is it better to automatically import local data or ask user if he wants this ?

              // TODO: or compare server & local data and ask users if he wants to import (locally & check which one needs to be saved on server as well)
              if (xhr.response.projects && xhr.response.projects.length) {
                projects = xhr.response.projects

                if (projects[0].slabs && projects[0].slabs.length) {
                  selected = projects[0].slabs[0].id
                } else {
                  // we have a project without any elements, so we need to create a blank one
                  const uuid = require('uuid-random')

                  selected = uuid()

                  let data = {
                    id: selected,
                    project_id: projects[0].id,
                    name: _this.$t('slab') + ' 1',
                    calculation_busy: 0,
                    calculation_date: '',
                    calculation_result: '',
                    calculation_pdf: '',
                    calculation_error: ''
                  }

                  _this.$store.dispatch('db/slabs/insert', {
                    data
                  }).then(() => {
                    _this.$store.commit('setElementId', selected)
                  })
                }
              } else {
                // create blank ? even if we had some local data as guest ?
                ({projects, selected} = createNewProject(_this.$store.getters))
              }

              // allow changes (in order not to yield if locked element with loads or openings)
              _this.$store.commit('allowChanges', true)

              _this.$store.dispatch('db/projects/create', {
                data: projects
              }).then(() => {
                _this.$store.commit('allowChanges', false)
              })

              _this.$store.commit('setElementId', selected)

              // reset & close form
              form.reset()

              uikit.modal('#logon-modal').hide()
            }
          } else {
            // insuccess
            const details = xhr.response && xhr.response.message ? xhr.response.message : _this.$t('unknown_error')

            // requet succeeded but server response failed
            uikit.notification(`<p class="uk-h3 uk-text-danger"><span class="uk-margin-small-right" uk-icon="ban"></span>${_this.$t('error_title')}</p><p>${details}</p>`, {pos: 'bottom-right', status: 'danger'})
          }

          _this.formIsBusy = false
        }, function (error) {
          const details = error.xhr.response && error.xhr.response.message ? error.xhr.response.message : _this.$t('unknown_error')

          uikit.notification(`<p class="uk-h3 uk-text-danger"><span class="uk-margin-small-right" uk-icon="ban"></span>${error.message}</p><p>${details}</p>`, {pos: 'bottom-right', status: 'danger'})

          _this.formIsBusy = false
        })
      } else {
        // fix validation errors
        uikit.notification(`<p class="uk-h3 uk-text-danger"><span class="uk-margin-small-right" uk-icon="ban"></span>${this.$t('warning_fix_errors')}</p>`, {pos: 'bottom-right', status: 'danger'})
      }
    },

    userSwitchTo (type, event) {
      let modal = event ? uikit.util.parents(event.target, '[uk-modal]') : null

      if (modal.length) {
        modal = modal[0]
      }

      const current = modal ? modal.getAttribute('id').replace('-modal', '') : null

      switch (type) {
        case null:
        default:
          if (current === 'logon') {
            this.userResetPasswordMode = !this.userResetPasswordMode

            if (modal) {
              setTimeout(() => {
                const input = modal.querySelector('input:not([disabled]):not([readonly])')

                if (input) {
                  input.focus()
                }
              }, 100)
            }
          }
          break

        case 'logon':
        case 'reset':
          this.userResetPasswordMode = type === 'reset'

          if (modal) {
            setTimeout(() => {
              const input = modal.querySelector('input:not([disabled]):not([readonly])')

              if (input) {
                input.focus()
              }
            }, 100)
          }
          break

        case 'account':
          if (current !== 'account') {
            uikit.modal('#account-modal').show()

            setTimeout(() => {
              const input = document.getElementById('account-modal').querySelector('input:not([disabled]):not([readonly])')

              if (input) {
                input.focus()
              }
            }, 100)
          }
          break
      }
    },

    userResetRestart (event = null) {
      let form = event ? uikit.util.parents(event.target, 'form')[0] : document.getElementById('logon-form')

      if (form) {
        // reset form
        form.reset()

        // clear all validation errors
        clearFormErrors(form)

        // put it in step 1 mode
        this.userResetPasswordStep = 1

        // remove busy mode
        this.formIsBusy = false

        // focus first input
        setTimeout(() => {
          const input = form.querySelector('input:not([disabled]):not([readonly])')

          if (input) {
            input.focus()
          }
        }, 100)
      }
    }
  }
}
</script>

<style scoped>
.uk-modal-footer {
  line-height: 38px
}
</style>



// WEBPACK FOOTER //
// src/components/Form/userLogonReset.vue